// import React from "react";

// const ProductBanner = () => {
//   return (
//     <div className="flex justify-center text-white z-50 product-banner">
//       <h1 className="text-white text-[28px] lg:text-[40px]  font-semibold leading-[97px] mt-[100px] max-md:mt-[70px]">
//         Products
//       </h1>
//     </div>
//   );
// };

// export default ProductBanner;
import React from "react";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { fetcher } from "../../../lib/apiConstants";

const ProductBanner = () => {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get("category") || "";

  // Fetch categories to get the display name
  const { data: categories } = useSWR("/categories/", fetcher);

  // Capitalize first letter of each word
  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  // Find the matching category to get its proper display name
  const getCategoryDisplayName = () => {
    if (!categoryParam) {
      return "Products";
    }

    // Find the category that matches the URL parameter
    const matchedCategory = categories?.find(
      (cat) => cat.name?.toLowerCase() === categoryParam.toLowerCase()
    );

    // Return the matched category name with proper capitalization
    if (matchedCategory) {
      return capitalizeWords(matchedCategory.name);
    }

    // Fallback: capitalize the URL parameter
    return capitalizeWords(categoryParam.split("-").join(" "));
  };

  const displayName = getCategoryDisplayName();

  return (
    <div className="flex justify-center text-white z-50 product-banner">
      <h1 className="text-white text-[28px] lg:text-[40px] font-semibold leading-[97px] mt-[100px] max-md:mt-[70px]">
        {displayName}
      </h1>
    </div>
  );
};

export default ProductBanner;
